module.exports = __webpack_public_path__ + "media/images/event/event-template-md-8057f4ab86a615aa59d11e1091788cbc.png";